import Breadcrumbs from "../../../components/breadcrumbs";
import AppFileCreateForm from "./ui/AppFileCreateForm";

export default function AppFileCreatePage() {
  return (
    <main className="max-w-3xl ">
      <Breadcrumbs
        breadcrumbs={[
          { label: "App Files", href: "/admin/app-files" },
          {
            label: "create",
            href: `/admin/app-files/Create`,
            active: true,
          },
        ]}
      />

      <AppFileCreateForm />
    </main>
  );
}
